export const Relationship = [
  { id: 'Spouse', name: 'Spouse', code: '007' },
  { id: 'Children', name: 'Children', code: '027' },
  { id: 'Friend', name: 'Friend', code: '029' },
  { id: 'Parent', name: 'Parent', code: '013' },
  { id: 'Sibling', name: 'Sibling', code: '024' }
];
